// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --tooltip-arrow-size:0.375rem;
  --tooltip-arrow-container-offset:calc(var(--tooltip-arrow-size)*-2);
  --tooltip-arrow-center-alignment-offset:calc(50% - var(--tooltip-arrow-size));
  --tooltip-font-size:0.875rem;
  --tooltip-line-height:1.25rem;
}
.tooltip{
  padding:0.25rem;
  font-size:0.875rem;
  line-height:1.25rem;
  color:#424242;
  background:#fff;
  border-radius:0.25rem;
  filter:drop-shadow(0 0 0.25rem rgb(0, 0, 0, 0.25));
}
.tooltip__text{
    padding:0 0.25rem;
  }
.tooltip__complex{
    padding:0 0.25rem;
  }
.tooltip__chevron{
    position:absolute;
    width:0;
    height:0;
    content:'';
    border-style:solid;
    border-width:0.375rem;
  }
.tooltip--above-auto .tooltip__chevron{
    bottom:-0.75rem;
    border-color:#fff transparent transparent transparent;
  }
.tooltip--below-auto .tooltip__chevron{
    top:-0.75rem;
    border-color:transparent transparent #fff transparent;
  }
.tooltip--left-auto .tooltip__chevron{
    right:-0.75rem;
    border-color:transparent transparent transparent #fff;
  }
.tooltip--right-auto .tooltip__chevron{
    left:-0.75rem;
    border-color:transparent #fff transparent transparent;
  }
.tooltip--above-center .tooltip__chevron,
  .tooltip--above-mouse .tooltip__chevron{
    bottom:-0.75rem;
    left:calc(50% - 0.375rem);
    border-color:#fff transparent transparent transparent;
  }
.tooltip--above-start .tooltip__chevron{
    bottom:-0.75rem;
    left:0.25rem;
    border-color:#fff transparent transparent transparent;
  }
.tooltip--above-end .tooltip__chevron{
    right:0.25rem;
    bottom:-0.75rem;
    border-color:#fff transparent transparent transparent;
  }
.tooltip--left-center .tooltip__chevron,
  .tooltip--left-mouse .tooltip__chevron{
    top:calc(50% - 0.375rem);
    right:-0.75rem;
    border-color:transparent transparent transparent #fff;
  }
.tooltip--left-start .tooltip__chevron{
    top:0.25rem;
    right:-0.75rem;
    border-color:transparent transparent transparent #fff;
  }
.tooltip--left-end .tooltip__chevron{
    right:-0.75rem;
    bottom:0.25rem;
    border-color:transparent transparent transparent #fff;
  }
.tooltip--below-center .tooltip__chevron,
  .tooltip--below-mouse .tooltip__chevron{
    top:-0.75rem;
    left:calc(50% - 0.375rem);
    border-color:transparent transparent #fff transparent;
  }
.tooltip--below-start .tooltip__chevron{
    top:-0.75rem;
    left:0.25rem;
    border-color:transparent transparent #fff transparent;
  }
.tooltip--below-end .tooltip__chevron{
    top:-0.75rem;
    right:0.25rem;
    border-color:transparent transparent #fff transparent;
  }
.tooltip--right-start .tooltip__chevron{
    top:0.25rem;
    left:-0.75rem;
    border-color:transparent #fff transparent transparent;
  }
.tooltip--right-end .tooltip__chevron{
    bottom:0.25rem;
    left:-0.75rem;
    border-color:transparent #fff transparent transparent;
  }
.tooltip--right-center .tooltip__chevron,
  .tooltip--right-mouse .tooltip__chevron{
    top:calc(50% - 0.375rem);
    left:-0.75rem;
    border-color:transparent #fff transparent transparent;
  }
.tooltip{
  padding:0;
}
.tooltip__text{
    padding:0;
  }
.tooltip__complex{
    padding:0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
